import { LaunchpadStatistics } from 'src/features/white-labels/ocean/launchpad/components/launchpad-statistics';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledAuthor = styled(Typography)`
    color: ${({ theme }: any) => theme.colors.warmBlack};
    padding: 0 10px;

    & span {
        margin-right: 5px;
        color: ${({ theme }) => theme.colors.blue};
    }

    ${media.sm`
        font-size: 16px;
        padding: 0 20px;
  `}

    ${media.md`
        padding: 0 80px;
  `}
`;

export const StyledLaunchpadStatistics = styled(LaunchpadStatistics)`
    padding: 0 10px;
    margin-left: 20px;
    background: ${({ theme }: any) => theme.colors.blue};

    ${media.sm`
        width: fit-content;
        margin: 0;
        padding: 0;
        border: 3px solid transparent;
        margin-left: 20px;
  `}

    ${media.md(css`
        width: min-content;
        min-width: 400px;
        margin-left: 20px;
    `)}
`;

export const StyledControls = styled(FlexBox)`
    position: absolute;
    top: 20px;
    right: 20px;
`;

export const StyledHeaderWrapper = styled.div`
    position: relative;
`;
